import { useHistory, useLocation } from 'react-router-dom';
import Tabs from 'lib/components/tabs/Tabs';

const TABS = [
  { label: 'Rules', path: '/settings/dynamic-modification-rules' },
  { label: 'Current stages', path: '/settings/dynamic-modification-rules/stages' },
];

export default function SettingsDynamicRulesNav() {
  const history = useHistory();
  const { pathname } = useLocation();

  return (
    <Tabs showSeparator className='settings-dynamic-rules-nav'>
      {TABS.map((tab) => (
        <Tabs.Item
          key={tab.path}
          active={pathname === tab.path}
          onClick={() => history.push(tab.path)}
        >
          {tab.label}
        </Tabs.Item>
      ))}
    </Tabs>
  );
}
